import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { AuthService } from '../../../service/auth.service';
import { ActionState } from '../../../model/enums/auth-state.enum';
import { ControlResendCodeComponent } from '../control-resend-code/control-resend-code.component';
import { ResetPasswordComponent } from '../../../component/reset-password/reset-password.component';
import { MfaComponent } from '../../../component/mfa/mfa.component';
import { ChangePasswordComponent } from '../../../component/change-password/change-password.component';
import { LoginComponent } from '../../../component/login/login.component';
import { ForgotPasswordComponent } from '../../../component/forgot-password/forgot-password.component';
import { ENVIRONMENT } from '../../../../../environments/environment';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss',
  providers: [],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class AlertMessageComponent {
  protected authService = inject(AuthService);

  @Input() parentComponent!:
    | LoginComponent
    | ChangePasswordComponent
    | MfaComponent
    | ResetPasswordComponent
    | ControlResendCodeComponent
    | ForgotPasswordComponent;
  @Input() dismissible = true;

  constructor() {
    const authService = this.authService;

    this.authService = authService;
  }

  iconsStyle = ENVIRONMENT.FONTAWESOME.style;
  iconSize = 'fa-lg';

  icons = {
    checkCircle: 'fa-circle-check',
    bellExclamation: 'bell-exclamation',
    ban: 'fa-ban',
  };
  protected readonly AuthMessageTypeEnum = ActionState;

  getAlertIcon(
    parentComponent:
      | LoginComponent
      | ChangePasswordComponent
      | MfaComponent
      | ResetPasswordComponent
      | ControlResendCodeComponent
      | ForgotPasswordComponent,
  ): string {
    return this.authService.getAlertType(parentComponent) ===
      this.AuthMessageTypeEnum.FAILURE
      ? this.icons.bellExclamation
      : this.icons.checkCircle;
  }
}
